/* Relevo beetroot PDP - Add to Cart -> single order -> Phoenix checkout.
   The reference sent each pack to an external subscription checkout; here each pack is a Relevo variant
   (data-variant on the pack label). Phoenix only catches /checkout via the Navigation API (missing on
   iPhone Safari / in-app browsers), so we hand off through a hidden button[name="checkout"], which
   Phoenix hooks in every browser. No Phoenix on the page -> native checkout. */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var phxBtn = null;
    if (window.__PHX_CHECKOUT_URL) {
      phxBtn = document.createElement('button');
      phxBtn.type = 'button'; phxBtn.name = 'checkout'; phxBtn.hidden = true; phxBtn.tabIndex = -1;
      phxBtn.setAttribute('aria-hidden', 'true'); phxBtn.className = 'bt-phx-checkout';
      document.body.appendChild(phxBtn);
    }
    function goCheckout() {
      if (!phxBtn || !window.__PHX_CHECKOUT_URL) { window.location.href = '/checkout'; return; }
      var left = false;
      window.addEventListener('pagehide', function () { left = true; }, { once: true });
      window.addEventListener('beforeunload', function () { left = true; }, { once: true });
      phxBtn.click();
      setTimeout(function () { if (!left && document.visibilityState === 'visible') window.location.href = '/checkout'; }, 8000);
    }
    function reset(btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.style.pointerEvents = ''; }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.upx .mpv1-switchers__cta-btn');
      if (!btn) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var box = btn.closest('mpv1-pack-selector');
      var radio = box && box.querySelector('.mpv1-switcher__radio:checked');
      var label = radio && radio.closest('label');
      var id = label && label.getAttribute('data-variant');
      if (!id) return;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none';
      var spin = btn.querySelector('.mpv1-switchers__cta-spinner'); if (spin) spin.style.display = 'block';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: '{}' })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); goCheckout(); })
        .catch(function (err) {
          console.error('[bt] add to cart failed', err);
          fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
            .then(function (c) { if (c && c.item_count > 0) { goCheckout(); return; } if (spin) spin.style.display = ''; reset(btn); })
            .catch(function () { if (spin) spin.style.display = ''; reset(btn); });
        });
    }, true);
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('.upx .mpv1-switchers__cta-btn').forEach(function (b) {
        var sp = b.querySelector('.mpv1-switchers__cta-spinner'); if (sp) sp.style.display = ''; reset(b);
      });
    });
  });
})();
